
<div class="auth-title">
  <h3>{{ 'update_password' | translate }}</h3>
  <p>{{ 'login_text' | translate }}</p>
</div>
<app-alert></app-alert>
<form class="auth-form-box" [formGroup]="form" (ngSubmit)="submit()">
  <div class="auth-box mb-3">
    <label for="newPassword">{{ 'new_password' | translate }}</label>
    <input type="text" class="form-control" id="email" placeholder="{{ 'new_password' | translate }}" formControlName="newPassword">
      @if(newPassword?.touched && newPassword?.errors?.['required']){
        <div class="invalid-feedback">
          {{ 'new_password_required' | translate }}
        </div>
      }@else if(newPassword?.touched && newPassword?.errors?.['newPassword']){
        <div class="invalid-feedback">
          {{ 'invalid_password' | translate }}
        </div>
      }
  </div>
  <div class="auth-box mb-3">
      <label for="confirmPassword">{{ 'confirm_password' | translate }}</label>
      <input type="text" class="form-control" id="email" placeholder="{{ 'confirm_password' | translate }}" formControlName="confirmPassword">
        @if(confirmPassword?.touched && confirmPassword?.errors?.['required']){
          <div class="invalid-feedback">
            {{ 'confirm_password_is_required' | translate }}
          </div>
        }@else if(confirmPassword?.touched && confirmPassword?.errors?.['confirmPassword']){
          <div class="invalid-feedback">
            {{ 'invalid_password' | translate }}
          </div>
      }
  </div>
  <app-button [class]="'btn'" [type]="'submit'" [id]="'send_otp'" [spinner]="true">{{ 'update' | translate }}</app-button>
</form>
